module.exports = __webpack_public_path__ + "static/img/jigou-beibuwan-top.f740eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-beibuwan-top.png
// module id = Zb9j
// module chunks = 2